<template>
  <div class="home" :class="lift ? '' : 'landing'">
    <object
      class="home__shapes"
      :class="lift ? 'show' : 'hide'
    ">
      <svg class="home__line" xmlns="http://www.w3.org/2000/svg"><path d="M0 409 579.817 0" stroke-width="0.0625rem" fill="none" fill-rule="evenodd"/></svg>
      <svg class="home__circles" viewBox="0 0 664 665" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <path d="M0 0h664v664H0z"/>
          <circle class="circle-ring3" stroke-width="1px" cx="332" cy="332" r="320"/>
          <circle class="circle-ring2" stroke-width="1px" cx="332" cy="332" r="240"/>
          <circle class="circle-ring1" stroke-width="1px" cx="332" cy="332" r="160"/>
          <circle class="sun-shape" stroke-width="2px" cx="332" cy="332" r="80"/>
          <g class="earth-rot">
            <path d="M0 0h188v188H0z"/>
            <circle stroke-width="2px" class="earth-shape" cx="93" cy="94" r="30"/>
            <circle stroke-width="1px" class="moon-shape" cx="93" cy="176" r="12"/>
          </g>
        </g>
      </svg>
    </object>
    <object data-relative-input="true" :class="lift ? 'hide' : 'show'" class="home__universe">
      <svg class="home__universe--human" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <path d="M42.8311 135.8406s27.54 14.945 34.628 16.051c7.088 1.105 16.46 7.154 26.121 14.296 9.66 7.141 14.77 6.292 19.576 13.175 4.805 6.884 26.956 17.082 12.386 21.058-19.473 5.314-30.164-6.864-35.339-8.967-5.176-2.102-28.716-3.954-31.43-10.647-2.713-6.694-10.415-16.671-17.536-18.759-7.121-2.088-7.005-7.119-20.197-13.827s-16.466-10.436-16.466-10.436l13.264.338s13.237 6.507 15.474 7.892c2.238 1.384 16.188 8.179 14.752 5.995-1.436-2.183-26.775-13.715-26.775-13.715l5.913-3.111 5.629.657Z" fill="#1C2B39" opacity=".5"/>
          <path class="human_light" d="M.0889 70.781c0 1.551.508 11.409 1.544 14.778 1.017 3.349 2.541 11.388 8.903 7.751 0 0-5.691-2.398-5.874-6.655 0-2.749 2.947-3.245 2.947-3.245s-5.792.702-6.098-8.247c-.284-8.97 4.513-12.008 4.513-12.008s-1.911-1.984-1.362-6.759c.569-4.754 7.418-8.226 7.418-8.226s-4.979.392-5.263-4.775c-.306-5.167 8.718-14.757 15.385-15.253-5.935-1.24-8.841-8.983-4.603-9.73 4.257-.75 5.761-1.286 6.879-1.266-1.992-.516-5.731-2.253-4.268-7.771 1.951-7.358 15.975-14.22 22.621.703-1.666-5.188-5.304-10.293-13.19-10.025-15.792.517-13.76 17.115-13.76 17.115s-2.541 0-2.805 3.368c-.244 3.349 1.495 7.398 1.495 7.398s-8.405 9.943-9.909 13.828c-1.504 3.886 1.036 5.954 1.036 5.954s-4.573 4.67-3.8 10.375c.752 5.705-1.809 11.14-1.809 12.69" fill="#FFD69C"/>
          <path class="human_light" d="M17.751 74.3982c4.918 5.519 7.622 7.503 13.536 7.503-4.675-2.997-10.081-5.498-11.808-9.735-1.728-4.258-2.216-10.768.487-13.021 2.703-2.232 5.65-6.986 5.65-6.986s-5.386-5.25-2.682-8.516c2.682-3.245 8.353-11.491 4.898-12.256-2.643-.579-5.894 3.762-8.353 5.249-2.46 1.51-5.163 12.774-4.187 14.014.996 1.261 6.158 2.501 6.158 2.501l-6.362 2.005s-2.256 13.744 2.663 19.242" fill="#FFD69C"/>
          <path d="M23.4537 79.782c-1.781-1.191-3.525-2.939-5.701-5.388-.634-.709-1.148-1.548-1.565-2.484-.249-.564-.466-1.159-.645-1.776-.281-.948-.492-1.95-.638-2.967-.06-.417-.114-.834-.158-1.257-.541-5.376.342-10.759.342-10.759l6.362-2.003s-1.976-.476-3.72-1.137c-.103-.038-.211-.081-.314-.119-.947-.379-1.781-.812-2.123-1.246-.579-.736.136-4.986 1.322-8.641.4-1.229.85-2.393 1.326-3.329.498-.986 1.024-1.728 1.538-2.042 2.458-1.489 5.712-5.827 8.354-5.247 2.188.482.715 3.969-1.342 7.289-.742 1.185-1.554 2.354-2.296 3.351-.455.611-.888 1.164-1.262 1.613-2.176 2.631.894 6.552 2.171 7.976.098.108.184.2.249.276.049.049.087.086.12.119.086.097.141.146.141.146s-.607.975-1.516 2.253c-1.1 1.538-2.654 3.514-4.132 4.732-1.186.986-1.76 2.799-1.879 4.873-.021.347-.027.699-.027 1.061.017 1.663.287 3.434.737 5.058.01.053.027.113.049.168.119.421.249.834.395 1.229.038.113.075.222.119.33.038.103.081.205.119.303 1.353 3.324 4.981 5.583 8.739 7.846 1.028.623 2.063 1.245 3.07 1.889-3.297 0-5.599-.617-7.835-2.117m34.778-8.192c-.006-.12-.017-.238-.033-.357-.016-.212-.032-.428-.054-.65-.016-.146-.027-.298-.043-.449-.06-.607-.119-1.246-.19-1.939-.503-5.143-1.738-8.982-1.765-14.078-.005-.06-.005-.119-.005-.184 0-.308 0-.633.005-.974 0-.304.006-.623.006-.948 0-.038.005-.081.005-.119.027-2.962.054-6.628-.439-9.762-.2-1.267-.487-2.448-.888-3.454-.384-.959-.872-1.766-1.494-2.351-1.792-1.689-3.52-3.616-4.716-5.225-.087-.114-.168-.227-.249-.34-.861-1.198-1.392-2.194-1.392-2.724 0-1.3.504-6.471-2.804-7.499 0 0 .303-5.231-1.322-10.401 0-.017-.021-.017-.021-.06-6.65-14.923-20.673-8.063-22.622-.704-1.462 5.517 2.274 7.255 4.266 7.775-.124 0-.254.005-.389.016-1.072.108-2.583.672-6.487 1.246-1.776.26-2.307 1.77-1.89 3.535.06.266.141.542.244.813.07.168.141.34.217.508.736 1.571 2.111 3.157 3.936 4.116.005 0 .005.005.005.005.217.108.433.211.661.308.455.19.931.342 1.43.444-2.167.163-4.582 1.284-6.845 2.903-2.88 2.057-5.517 4.922-7.076 7.635-.666 1.153-1.132 2.273-1.343 3.296-.109.504-.152.975-.125 1.419.287 5.171 5.263 4.776 5.263 4.776s-2.929 1.483-5.117 3.844c-1.153 1.246-2.1 2.735-2.3 4.38-.547 4.776 1.364 6.763 1.364 6.763s-2.686 1.7-3.915 6.309c-.059.215-.114.438-.162.671-.022.081-.038.162-.055.244-.113.551-.205 1.136-.27 1.764-.06.515-.092 1.051-.108 1.619-.017.422-.017.856 0 1.305v.092c.303 8.95 6.096 8.252 6.096 8.252s-2.95.493-2.95 3.243c.184 4.256 5.874 6.654 5.874 6.654 3.557-2.853-.244-9.052-.244-9.052l.607-6.459.146-1.582.022.146s.596 1.462 1.408 3.336c.032.081.07.173.108.26.249.573.514 1.175.785 1.781.07.151.141.303.206.46.308.672.617 1.343.92 1.971.098.206.195.401.293.595.216.434.422.834.617 1.192.103.189.2.362.292.525.081.141.157.271.233.385.054.086.108.167.157.243 2.355 1.505 3.395 2.707 3.395 2.707h-4.207s2.133 2.562 1.846 6.779c-.303 4.197-3.308 9.774-2.54 11.577.775 1.798 3.58 3.757 3.58 3.757h-2.886s.005.179.016.488c.005.054.005.113.011.173.016.357.038.85.07 1.429.006.098.011.201.017.304.037.633.086 1.358.146 2.133.016.184.032.374.048.568.039.493.087 1.002.141 1.517.016.179.033.362.054.541.028.244.054.487.087.731.016.152.032.309.054.46.016.098.027.195.038.292.021.168.049.331.07.493.016.124.038.249.054.373.017.098.033.191.044.283.032.183.06.362.092.541v.01c.049.272.103.537.152.791 0 .016.005.028.01.039.033.156.065.313.098.459l.016.065c.044.168.081.331.125.487.043.157.086.309.13.455.01.033.016.066.027.092.059.179.124.353.184.504.097.244.2.455.309.623.037.06.081.124.119.19 1.548 2.479 2.317 4.97 1.31 6.156-1.034 1.196-2.821-.872-4.099 1.294-.005.01-.011.015-.017.027-1.277 2.209-.005 4.337-.005 4.337s9.481 2.637 12.849.86l.065-.536 1.175-9.248c-.222-.784-.303-2.626-.547-2.896-.33-.347-.585-3.963-.666-8.674-.168-9.736.39-24.149 2.453-23.982 3.07.272.818 14.604 1.386 20.267.043.396.254 1.798.525 3.715.607 4.283 1.494 11.11 1.338 14.836-.119 2.804-2.172 1.754-2.697 3.362-.552 1.679.428 2.188.834 2.805.124.195.536.368 1.126.514 3.119.758 11.393.769 11.533-.72.027-.298.044-.856.044-1.624.01-3.801-.261-12.649-.498-19.173-.142-3.915-.271-6.99-.315-7.64-.216-2.93 2.518-12.145 3.861-17.446.422-1.694.709-2.983.709-3.546 1.527 4.137 5.344 5.436 8.133 1.797 2.804-3.616 1.278-4.38 2.03-9.568.082-.541.152-1.055.211-1.542.363-3.016.331-5.084.109-7.754" fill="#15202F"/>
          <path class="human_light" d="M17.3843 125.9685c1.548 2.479 2.317 4.971 1.31 6.156-1.034 1.197-2.821-.872-4.099 1.294-.005.011-.01.016-.016.028-1.278 2.209-.006 4.336-.006 4.336-2.436-.801-7.108-3.259-1.856-6.313 3.34-1.949 3.427-4.202 2.393-7.326-1.018-3.097-.753-8.533-2.036-13.455-.693-2.713.363-10.672.043-19.075-.26-6.888-1.943-14.647-2.052-15.253 0 0 .596 1.462 1.408 3.336.032.085.07.172.108.259.249.574.514 1.175.785 1.782.071.151.141.308.206.46.309.671.617 1.342.92 1.97.098.2.195.402.293.596.216.434.422.834.617 1.191.103.19.2.363.293.526.081.14.156.27.232.384.055.086.108.167.157.244 2.356 1.505 3.395 2.707 3.395 2.707h-4.207s2.133 2.561 1.846 6.779c-.303 4.196-3.308 9.773-2.539 11.576.774 1.798 3.579 3.758 3.579 3.758h-2.886s.006.179.016.487c.006.054.006.114.011.173.017.358.038.851.07 1.43.006.097.012.2.017.304.038.632.086 1.358.146 2.132.016.185.033.374.049.569.038.493.086 1.002.14 1.516.017.184.033.363.055.541.027.244.054.488.087.732.016.151.032.308.053.46.017.097.028.194.038.292.022.168.044.331.071.493.016.124.032.249.054.373.016.098.033.19.043.282.027.184.06.368.092.541v.011c.049.271.098.536.152.791 0 .016.005.027.011.038.027.156.065.309.097.46l.016.064c.039.168.082.331.125.488.038.157.086.314.13.455.011.032.016.065.027.092.059.178.119.352.184.504.097.244.2.455.309.623.037.059.081.124.119.189" fill="#FFD69C"/>
        </g>
      </svg>
      <svg class="home__universe--leftrock" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <path d="m229.1793 235.4275 11.854 18.501s-7.216 5.616-4.787 9.587c2.429 3.972-.308 16.754-.308 16.754l5.095 13.717s-15.057 15.628-23.604 16.482c-8.547.855-21.544 32.063-21.544 32.063l-51.06 15.397-65.16-12.68-79.2 16.303v-151.654l228.714 25.53Z" fill="#1C2B39" opacity=".50152853"/>
          <path fill="#1C2B39" d="M24.8756 69.1081.5816 87.8191.6436.3601l8.231 35.693 32.905 19.638-30.795 13.417zM229.1788 235.4285l-39.15-2.181-11.969 6.534h-57.682c-4.353 0-37.002 4.352-37.002 4.352l3.27 9.796c-18.5 0-86.181-7.615-86.181-7.615l.117-158.495 36.052-13.075 28.973 7.227 9.009 31.255-47.357 27.603 36.199-13.688 29.69 5.987 13.058-5.442 42.78 25.033-13.931 15.301-43.324 12.451 17.559-2.095 36.09-7.156h15.238l5.443 22.854 12.809 3.542 3.52 6.277-12.038 11.423 27.416-14.452 13.697 16.196 11.68 6.844 6.034 11.524Z"/>
          <path class="rock_lighter" fill="#FFD69C" d="m74.6158 113.2263-11.158 13.915-36.199 13.689zM148.9854 152.7195l-3.605 18.501-36.091 7.156-17.558 2.095 43.324-12.451zM197.7682 200.864l-27.417 14.452 12.039-11.423zM41.7799 55.6911l-5.146 19.054-36.052 13.074 24.294-18.711h-13.891z"/>
          <path d="M129.192 111.0466c7.163-6.411 17.638-8.939 15.566-9.949-4.066-1.984-19.163 4.491-29.175 14.737 2.467-8.42 4.901-17.601 3.499-17.466-1.561.151-6.301 10.325-9.322 19.135-.156-10.546-2.697-23.566-4.972-22.916-2.196.627-2.142 11.205-2.03 21.494-3.64-6.552-8.308-13.827-9.674-13.38-.848.278-.747 3.423.23 7.673-.343-.413-.688-.824-1.033-1.229-6.308-7.412-15.896-12.287-17.492-11.418-1.639.891 8.954 8.484 14.924 17.973 4.572 7.267 6.276 15.017 13.106 18.262l6.503-.016s6.936-7.933 14.307-12.926c6.317-4.28 13.383-5.62 11.841-6.757-1.432-1.057-8.153-.306-10.778 1.151 1.46-1.517 2.965-2.994 4.5-4.368" fill="#15202F"/>
        </g>
      </svg>
      <svg class="home__universe--rightrock" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <path fill="#1C2B39" opacity=".50152853" d="m356.5987 440.8562 36.723 11.738 16.944 10.741 63.2 9.928 13.504 17.383 31.992 1.583 31.943 20.615-9.68 19.533 30.976 11.802 39.412 22.157h64.6l40.45-23.806 49.135-17.317 126.045-6.025 36.576 13.189h90.991l57.316 12.627v-107.265l-277.593 4.289 88.323 12.08 25.862 12.498-44.365 7.571-31.524-8.335-24.153 5.913-46.701-5.419-1.987-7.798-23.068-6.994-9.015-7.945-148.76-5.86z"/>
          <path fill="#1C2B39" d="M1077 .955258V434.905l-158.2028 19.8464-119.667-11.541-27.081-5.476 21.807-33.059 15.903 3.336 46.572-4.63-29.525-5.099v-16.937l29.525 6.611-20.947-12.247 9.686-28.438 15.418-25.541 2.609-30.341 18.622-1.245 33.654 4.84-29.452-7.767-5.621-15.812 11.819-2.599 52.807 3.235-54.492-6.462 2.463-16.45-12.597-13.143 42.279-8.395-27.191.439-12.296.199-13.046-6.582-21.378-18.66-41.683 11.48h-19.015l60.698-19.147-58.538 12.804-24.499 4.511-17.652-.707-9.732 7.061-18.63 2.13-16.818 25.63-31.54 14.399 6.171 20.263 2.737 8.982 13.98 1.374 9.613-3.754-3.717 20.612-16.983 22.116-10.922 19.108-30.304 11.242 9.21 13.861 4.221 6.353-12.231 5.894 17.284 1.713 26.697 10.545 1.483 25.8 35.064 2.499 8.945 17.466-108.718 18.112-16.296-14.199-44.678 6.105-51.333-11.821-55.453 14.488-46.728-2.458-11.572-6.862-41.134-6.87 23.272-4.909 17.496-5.118 8.798-8.633.009-.01.009-.011 8.762-26.476 15.701 3.635 16.04-3.635 8.761-3.356-.64-5.606-3.059-23.698 75.128-13.593-42.214 4.461 31.594-28.736-6.28-.449-6.281-6.99 5.521-2.092-1.914-16.121-2.17.608-12.066 3.356-14.356-14.797 7.746-7.568 10.556-45.934-12.204 35.668 4.294-44.122 41.784-16.25-33.966 8.972-3.854-13.164 86.178-5.657-86.178 1.395-26.889-8.902 15.491-27.573-2.958 18.76 3.882 5.298 1.026-27.532v-.01l.43-.768 21.432 2.62 85.794 7.716 47.836-24.684 29.049-46.362 56.973-23.7680002 14.447-17.824 35.046-2.38 60.8 29.534 32.428-2.211-4.752 11.7 29.159-33.576 39.45-4.73-2.417 35.1 8.716-33.108 8.716-25.74 31.384 4.45 49.337-5.805 22.522-9.42z"/>
          <path fill="#15202F" d="m792.3273 155.3757 6.415 17.121-37.929 5.022-24.542 13.649-5.577 10.92 11.155-8.103 35.976-11.31 56.056 7.279 17.291-11.223-7.251-16.378-4.722 6.976-27.35-18.741 6.47-19.175-52.207 23.357zM901.4386 193.9851h36.565l26.924-13.972h32.903l31.83-35.933 13.59 45.51-46.135 87.91-2.861-26.84-30.399-18.871 26.465-13.026-49.712.779-39.17-5.07 34.521-7.321-23.348-6.583h-28.51z"/>
          <path class="rock_lighter" fill="#FFD69C" d="m579.2404 201.4929-86.178 5.656v-4.261zM530.8824 211.3416l-41.785 16.25 7.819-7.278zM497.0079 236.0456l-10.556 45.934-7.745 7.568 6.042-17.247.055-.587z"/>
          <path class="rock_light" fill="#FFD69C" d="m484.8043 271.7136-.055.587-6.043 17.247z"/>
          <path class="rock_lighter" fill="#FFD69C" d="m526.8721 350.3073-75.127 13.593 9.539-10.416 25.488-1.235-2.114 2.519zM535.1866 223.1892l-16.498 8.308 19.248-2.327 43.993-13.624z"/>
          <path class="rock_light" fill="#FFD69C" d="m516.2525 326.032-31.595 28.736 25.314-29.184zM484.0445 151.2683l-.431 11.66v.01l-1.025 27.532-3.882-5.298 2.958-18.759v-.01z"/>
          <path fill="#1C2B39" d="m484.0474 151.2703 11.203 5.033 10.229 8.476 16.295 1.466-9.798 14.692-29.39 9.536z"/>
          <path class="rock_lighter" fill="#FFD69C" d="m509.212 316.5017-5.521 2.092 1.438-17.606 2.169-.607zM455.4434 393.2048l-8.762 3.355-16.039 3.635-15.701-3.635 12.332-7.089 27.529-1.872zM399.0274 439.1911l10.042-3.871 21.23-2.074 30.001 1.244-22.247 2.765-29.11 4.978z"/>
          <path class="rock_light" d="m406.1612 423.0573-8.798 8.633-17.496 5.118-23.272 4.909 38.726-11.819 10.812-6.831c.009-.01.019-.01.028-.01" fill="#FFD69C"/>
          <path class="rock_lighter" d="m406.17 423.0476-.009.01c-.009 0-.018 0-.028.01l.037-.02Z" fill="#FFD69C"/>
          <path class="rock_light" fill="#FFD69C" d="m591.7418 200.5681 15.086-23.406 36.524-17.704-32.951 20.555zM497.0079 371.8532l30.832-4.033 36.734-72.342 7.675-3.708-43.135 78.181-7.756 1.902z"/>
          <path fill="#15202F" d="m581.9293 294.8005 25.314 9.546-4.394 50.427-17.84 29.355 11.401 9.768-25.618 47.821 31.554-9.34 6.368-32.183 24.717-9.359-34.352-9.113 12.149-22.352.931-30.062 34.511-10.715h-33.776l.139-50.899-8.312-4.898.971 28.974z"/>
          <path class="rock_light" fill="#FFD69C" d="m703.7155 104.8767-27.502 19.685-2.663 14.132 6.974-14.356 36.135-22.887zM666.0314 211.9275l42.93-35.149 11.576-31.479 58.848-12.066 59.813-25.182-55.185 28.046-60.198 11.375-12.9 30.642zM944.9264 272.0417l-52.807-3.235-11.819 2.598 10.134-5.825zM915.3737 294.9841l-33.655-4.84-18.621 1.245 22.823-4.172zM856.3317 387.9568l-29.525-6.611 8.578-5.636zM856.3317 403.3816l-46.573 4.63-15.902-3.336 32.95-6.393zM604.7218 262.7966l61.31-8.933-52.999 13.83zM848.6686 195.3201l-60.699 19.147 2.161-6.342z"/>
          <path fill="#15202F" d="M702.799 246.7497h-67.422l14.278 9.5 16.376-2.386 5.228 7.284z"/>
          <path class="rock_lighter" fill="#FFD69C" d="m892.2565 62.9254998-29.159 33.576 4.751-11.7zM946.7208 34.4469998l-8.716 25.74-8.716 33.109 2.417-35.101zM1076.7247 33.1715998v1.425l-.009.01-27.008 7.069-20.682 31.864-44.613 35.9460002 35.843-32.5700002 7.855-9.012 17.642-29.833 30.963-4.899zM922.5787 227.5915l-42.279 8.395 15.088-7.957zM554.3556 267.6941l24.882-25.791 47.313-14.311-45.753 16.09zM451.7413 416.7165l28.797-22.82 46.331-6.298-44.233 9.562zM509.212 432.3777l23.469-19.572 12.885 3.911 18.281-12.314 15.283-24.841-12.287 29.333-20.977 12.385-13.185-4.563zM774.6212 57.4782998l-35.046 2.38-14.447 17.824-56.973 23.7690002-29.049 46.361-47.836 24.685-85.794-7.717-3.295-2.739 88.274 6.084 46.911-24.744 28.665-49.1200002 56.323-20.89 16.351-17.018 28.455-1.544zM906.3907 93.2956998 856.3277 130.5857l-9.977 20.002 12.548-18.05zM687.0153 399.4577l-26.697-10.545-17.284-1.713 12.231-5.894-4.221-6.353zM723.5626 427.7566l-35.729-14.058.665 11.559zM912.6115 163.4412l73.951-20.764 14.507-22.605-11.122 25.724-70.607 17.884-20.312 22.091zM703.7599 288.0134l-9.613 3.754-13.98-1.374-2.737-8.982z"/>
          <path fill="#1C2B39" d="m696.087 313.7849 6.712 3.002-4.576 11.56-20.34 11.453 5.177-9.059z"/>
          <path fill="#15202F" d="m465.1651 437.739 10.79 8.413h16.758l10.79-8.413-22.498 3.979zM708.9611 176.7781l-42.93 35.149 3.056-45.518 21.509 17.762 13.164-11.674-19.509-29.81 41.637-16.821h55.121l32.367-6.943-33.99 14.31-58.848 12.066zM581.9293 215.5466l4.434 13.771 40.187-1.725 20.12-20.441-23.989 16.371-11.54-7.976-17.311-11.7-2.088 11.7zM524.1651 250.905v18.827l-7.913 10.899 12.241-3.054 6.135 24.712 19.727-15.699-6.748-9.994-.721-8.902 28.241-31.648h-52.42z"/>
          <g fill="#1C2B39">
            <path d="m.2525 460.5466 5.085-6.531 13.267-2.979 8.452-8.398h5.547l10.311 8.964 1.724 5.86 8.291 1.492 4.048 5.262-34.869 2.209zM281.4547 458.4109l4.69-9.649 12.062-4.316v8.236l13.269 3.619 3.016 4.442h-22.617z"/>
            <path opacity=".50152853" d="m56.9771 464.2165-3.04 2.189-3.22 1.652.44 3.367-8.616 3.928-6.193.779-12.707-4.303-8.488-5.403-14.901-5.879zM281.4547 458.4109l7.299 4.171 16.047 2.493v-2.337l8.101-.995 1.59-1z"/>
          </g>
          <g>
            <path d="M720.9146997 537.5544s49.42 3.01 60.668 12.213c11.249 9.203 30.6770003 9.696 30.6770003 9.696l65.444 17.287h51.127l-4.09 12.897h46.015l76.691 37.834 29.279 2.788v-116.797l-355.8110003 24.082Z" fill="#1C2B39" opacity=".50152853"/>
            <path d="M730.7686997 497.0251c-9.243-8.273-22.76099997-11.535-20.08699997-12.839 5.247-2.558 20.93099997-2.349 33.85199997 10.873-3.184-10.865-4.611-20.122-2.802-19.946 2.014.194 11.217 10.613 15.116 21.981.201-13.609 10.365-34.384 13.299-33.546 2.834.81-5.123 26.697-5.268 39.974 4.698-8.454 17.159-34.153 18.922-33.576 1.093.358-5.474 20.727-6.734 26.212.442-.533.887-1.063 1.332-1.586 8.141-9.564 14.665-8.52 16.725-7.399 2.116 1.152-5.708 3.614-13.412 15.858-5.899 9.377-8.097 19.378-16.912 23.564l-8.391-.019s-3.126-7.717-13.939-13.084c-8.794-4.365-25.69599997-6.156-25.69599997-9.227 0-2.295 16.41499997-3.484 19.80099997-1.603-1.884-1.958-3.826-3.865-5.806-5.637" fill="#15202F"/>
            <path d="m720.9146997 537.5544 5.943-12.474 29.992-8.878 7.43-9.37 14.104-3.948 40.7270003-29.666 8.466-35.554h23.702l18.624-28.782 34.592-31.824 61.23-7.554 5.763-28.11-11.854-34.094 11.78-14.781 25.73-11.6150001 16.667-44.712L1077 190.067617V554.77859S971.4387 566.3354 942.6577 566.3354l5.079-15.237s-50.792-6.773-57.564-6.773h-89.7310003l-18.624-10.158-60.903 3.387Z" fill="#1C2B39"/>
            <path class="rock_lighter" fill="#FFD69C" d="m827.5763 437.6648 50.92 8.314 52.434-.088 62.384-.999-66.548-.965-45.836-1.285-29.651-4.977zM756.8491997 516.2029l28.726-6.507 59.9280003-3.677h-59.0840003l-22.139.814zM904.4943 377.0583l31.967-5.17 21.101-5.411 8.877-25.083-6.802-34.097 11.85 34.097-5.763 28.11z"/>
            <path d="M947.7365 551.0984s10.813-57.598 12.205-60.844c1.391-3.246 28.749-28.75 28.749-28.75l-31.996 4.174-46.249 11.297-57.267-1.877 27.751 16.547-13.114 14.374 37.393 19.061 9.29 12.936 33.238 13.082ZM998.1388 431.3191l33.784-54.261-56.531 38.354-56.53 2.947 42.369 16.129z" fill="#15202F"/>
          </g>
        </g>
      </svg>
      <svg class="home__universe--ground" xmlns="http://www.w3.org/2000/svg"><path d="m1441 0-.275 326H.725V0z" fill="#E6B277" fill-rule="evenodd"/></svg>
      <svg class="home__universe--spaceship" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <g fill="#1C2B39">
            <path d="M817.794499 210.3034c-.09-8.58-.83-47.54-6.8899997-47.96-4.5.14-8.92 1.239-12.96 3.22l-82.48999999 40.36c-3.01 1.47-1.96 6.01 1.39 6.01H816.044499c.92 0 1.69-.72 1.75-1.63"/>
            <path d="m934.184599 205.9236-82.48-40.36c-2.49-1.217-5.116-2.099-7.815-2.632v-.001c-.007-.002-.013-.003-.02-.004-.346-.068-.695-.122-1.043-.179-7.39-1.421-1.486-4.629-1.486-21.795 0-.093-.017-.181-.021-.274.011-.202.021-.403.021-.605v-21.603s-.975-.667-3.65-1.318v-22.06s-2.473-1.9-12.869-1.9c-.946 0-1.826.015-2.645.043-5.706.2-10.2229997 4.879-10.2229997 10.588 0 5.122 3.6879997 9.372 8.6989997 10.432 1.446.306 2.89.829 4.169 1.681-3.976 0-7.073.242-9.453.576-4.0219997.565-6.7589997 4.345-6.0409997 8.342 0 5.528.917 10.156 2.419 14.056.043.116.073.222.118.338.05.131.105.261.156.391.019.045.037.092.055.136 3.7469997 9.243 12.7089997 18.256 9.7269997 44.509-3.652 32.137 6.074 27.649 11.802 27.649h99.19c3.36 0 4.41-4.54 1.39-6.01M833.676299 215.1667c-1.683.576-4.635 1.3-8.854 1.3-4.23 0-7.186-.728-8.867-1.305-1.011-.347-2.123.078-2.6699997.997l-8.574 14.401h40.0689997l-8.427-14.383c-.544-.927-1.66-1.359-2.677-1.01M824.497599 76.3386c.107-.001.215-.001.324-.001 10.908 0 12.869 2.633 12.869 2.633v-23.545l-4.61-4.474v-4.381c0-4.561-3.644-46.261-8.259-46.261s-8.259 41.7-8.259 46.261c0 0 5.198-.177 8.259 2.521-6.434 0-8.259 1.86-8.259 1.86-2.9469997 2.86-4.6089997 6.791-4.6089997 10.898v2.048c0 6.914 5.6289997 12.474 12.5439997 12.441"/>
            <path d="M805.1601993 94.07c2.918-1.554 9.9909997-4.679 19.6619997-4.679s16.743 3.125 19.661 4.679c.669.356 1.475-.122 1.475-.88v-3.115c0-2.569-1.47-4.901-3.778-6.03-3.622-1.773-9.668-3.974-17.358-3.974-7.69 0-13.7369997 2.201-17.3589997 3.975-2.307 1.128-3.778 3.46-3.778 6.029v3.115c0 .758.807 1.236 1.475.88"/>
          </g>
          <g class="home__universe--spaceship--dust" fill="#FFD69C">
            <path class="home__universe--spaceship--dust1" opacity=".65" d="M802.2745 214.5632c-1.48-10.02-13.47-17.64-24.93-11.47-3.08-6.341-10.61-8.51-13.2-4.42-6.16-18.01-26.06-31.1-49.48-18.01-4.89-7.93-26.29 2.31-29.14 11.27-7.2-11.97-30.19-29.17-56.35-25.71 6.573-47.7529997-56.25-84.2019997-96.951-40.1299997 0-64.61-114.111-125.784-194.883-62.062-80.772 63.722-31.406 166.1219997-31.406 166.1219997h279.76c.13.27.21.41.21.41h238.84c0-6.77-6.79-20.75-22.47-16"/>
            <path class="home__universe--spaceship--dust2" opacity=".65" d="M20.134797 216.750131c1.268745-8.650435 11.547292-15.22891 21.371491-9.902245 2.640361-5.474292 9.095529-7.346826 11.315832-3.81586 5.280721-15.548337 22.340195-26.849155 42.417223-15.548337 4.192001-6.846103 22.537365 1.994262 24.980556 9.729581 6.172271-10.333903 25.880678-25.182953 48.306599-22.195877-5.63477-41.2259696 48.220873-72.6930058 83.112211-34.644905 0-55.7789025 97.822792-108.59144815 167.0653942-53.5791711C487.9467053 141.805594 445.6272098 230.20924 445.6272098 230.20924H205.800161c-.111444.233096-.180024.35396-.180024.35396H.872166c0-5.844655 5.820795-17.913825 19.262631-13.813069M1245.658296 97.3894003c-64.521-50.99999999-155.674-2.039-155.674 49.6709997-18.965-20.5739997-43.937-19.2179997-60.418-6.934-31.951996-.594-56.795996 21.135-63.179996 38.678-2.851-8.957-23.464-2.949-17.529 7.923-5.935-9.435-52.28-11.623-51.976 16.432-9.496-17.77-47.74-11.225-51.091 15.31-15.677-4.751-21.044 5.325-21.044 12.09h261.218996s.035-.078.095-.215h184.685s39.434-81.955-25.087-132.9549997"/>
            <path class="home__universe--spaceship--dust3" opacity=".65" d="M1230.162466 115.2128537c64.92512-44.1741674 156.64905-1.7661005 156.64905 43.0230403 19.08379-17.820379 44.21219-16.645865 60.79642-6.005954 32.15213-.514499 57.15174 18.306295 63.57572 33.501342 2.86886-7.758196 23.61097-2.554306 17.63879 6.862587 5.97218-8.172221 52.60745-10.06738 52.30155 14.232743 9.55548-15.391665 48.03901-9.722647 51.411 13.260912 15.77519-4.115127 21.17581 4.612303 21.17581 10.471876h-262.85512s-.03522-.06756-.09559-.186224h-185.84176s-39.68099-70.986155 25.24413-115.1603223"/>
          </g>
        </g>
      </svg>
      <svg class="home__universe--mountains" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <path fill="#CC9E6A" d="M800.7247 2.1833v12.75h-762.23l15.79-14.11z"/>
          <path class="mountain_light" fill="#E6B277" d="M800.7247 14.9333v8.53l-786.58-2.53 24.35-6z"/>
          <path fill="#CC9E6A" d="M.2735 39.5593h800.452v-16.093l-786.577-2.537z"/>
        </g>
      </svg>
      <svg class="home__universe--clouds" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <path class="home__universe--clouds--cloud1" d="M759.574799 30.1569999c-1.942-5.58-7.247-9.269-15.681-7.089-8.434 2.181-10.535 7.726-10.64 13.414-9.728-18.825-60.134-34.54499995-83.085-3.531-9.56-9.013-28.079-6.431-29 13.338-12.895-18.415-38.848-27.422-64.964-20.635-28.266 7.347-47.365 30.763-46.938 55.213-1.659-.029-3.346.144-5.03.582-9.976 2.593-15.962 12.782-13.369 22.7590001.72 2.768 2.04 5.215 3.762 7.27-15.271 6.076-30.284 13.942-50.047 21.662-2.927 1.144-1.602 5.533 1.466 4.848 89.071-19.858 233.998-64.6010001 233.998-64.6010001s157.845-43.187 237.186-67.89599995c3.075-.958 1.882-5.554-1.274-4.909-44.532 9.101-77.755 12.26099995-156.384 29.57499995" fill="#F4C993" opacity=".75334676"/>
          <path class="home__universe--clouds--cloud2" d="M90.9604995 105.9832c-.471-2.937 1.321-5.9500001 6.316-7.2550001 4.9949995-1.304 7.5739995.539 9.1449995 2.9770001.071-10.7540001 19.779-42.8310001 40.061-35.5090001 2.599-6.456 19.486-8.38 25.24-.057 16.457-14.063 30.052 5.604 30.052 5.604s19.466-20.183 33.701-10.533c.86-.456 1.789-.83 2.787-1.089 5.912-1.536 11.762 1.284 13.066 6.299.361 1.392 10.002.29 9.649 1.64 9.611-1.438 77.636-17.127 90.038-19.05 1.837-.285 2.314 1.97.526 2.492-51.909 15.146-207.433 52.0100001-207.433 52.0100001s-94.1209995 23.376-142.23099952 33.825c-1.865.405-2.466-1.906-.643-2.468 25.73200002-7.931 43.96100002-15.422 89.72600002-28.886" fill="#F4C993" opacity=".74918329"/>
          <path class="home__universe--clouds--cloud3" d="M796.185199 253.3552c-.872-2.156-3.932-3.346-9.268-1.964-5.337 1.383-6.96 3.763-7.359 6.084-4.903-7.09-38.069-19.469-54.064-5.501-5.375-3.106-22.3 3.214-24.029 11.313-21.974-1.913-26.06 17.222-26.06 17.222s-27.588-4.611-36.785 8.179c-1.023.086-2.076.256-3.141.532-6.314 1.642-10.608 6.14-9.593 10.047.282 1.084-9.382 4.689-8.438 5.424-9.789 3.369-81.534 23.568-94.193 27.871-1.875.638-1.314 2.345.62 1.887 56.176-13.312 220.656-58.831 220.656-58.831s100.02-26.843 150.47-41.557c1.955-.57 1.489-2.37-.498-1.923-28.037 6.319-48.741 9.555-98.318 21.217" fill="#FFD69C" opacity=".75091843"/>
        </g>
      </svg>
      <svg class="home__universe--sun" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
              <path d="M1155.40507,853.9939 L113.725067,853.9939 L113.725067,59.9639 C584.045067,59.9639 1030.90507,423.7839 1155.40507,853.9939" id="path-l4pf_wxxdj-1"></path>
              <filter x="-21.6%" y="-28.3%" width="144.6%" height="156.7%" filterUnits="objectBoundingBox" id="filter-l4pf_wxxdj-2">
                  <feMorphology radius="5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology>
                  <feOffset dx="0" dy="0" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
                  <feGaussianBlur stdDeviation="20" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                  <feColorMatrix values="0 0 0 0 1   0 0 0 0 0.968627451   0 0 0 0 0.921568627  0 0 0 0.49889606 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
                  <feMorphology radius="25" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter2"></feMorphology>
                  <feOffset dx="0" dy="0" in="shadowSpreadOuter2" result="shadowOffsetOuter2"></feOffset>
                  <feGaussianBlur stdDeviation="50" in="shadowOffsetOuter2" result="shadowBlurOuter2"></feGaussianBlur>
                  <feColorMatrix values="0 0 0 0 1   0 0 0 0 0.968627451   0 0 0 0 0.921568627  0 0 0 0.501783288 0" type="matrix" in="shadowBlurOuter2" result="shadowMatrixOuter2"></feColorMatrix>
                  <feMerge>
                      <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                      <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
                  </feMerge>
              </filter>
          </defs>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="left-sun">
                  <use fill="black" fill-opacity="1" filter="url(#filter-l4pf_wxxdj-2)" xlink:href="#path-l4pf_wxxdj-1"></use>
                  <use fill="#FFF7EB" fill-rule="evenodd" xlink:href="#path-l4pf_wxxdj-1"></use>
              </g>
          </g>
      </svg>
      <svg @click="lift = !lift" class="home__universe--planet" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient x1="1.01341932%" y1="99.0153109%" x2="89.5711588%" y2="12.9681617%" id="a">
            <stop stop-color="#DCA051" stop-opacity=".72984218" offset="0%"/>
            <stop stop-color="#8A6D56" stop-opacity="0" offset="100%"/>
          </linearGradient>
        </defs>
        <path d="M1331.62783 0c119.01737 0 215.5 96.4826364 215.5 215.5 0 119.017364-96.48263 215.5-215.5 215.5-119.01736 0-215.5-96.482636-215.5-215.5 0-119.0173636 96.48264-215.5 215.5-215.5Z" transform="translate(-1116.127834)" fill="url(#a)" fill-rule="evenodd"/>
      </svg>
    </object>
    <section class="cover ">
      <div class="-full">
        <h1 title="... Et parfois je m'aventure dans d'autres univers, tout aussi passionnants." :class="lift ? 'hide' : 'show'" data-splitting class="cover__title experiment-split -h3">
          <span>... Et parfois je m'aventure dans d'autres univers, <strong>tout aussi passionnants.</strong></span>
        </h1>
        <h1 title="Bonjour. Je m’appelle Centis. J'adore les interfaces efficaces. Mon travail, c'est de les concevoir." :class="lift ? 'show' : 'hide'" data-splitting class="cover__title welcome-split -h3">
          <span class="-partOne"><strong>Bonjour.</strong> Je m’appelle <i>Centis</i>.</span>
          <span class="-partTwo">J'adore les interfaces efficaces.</span>
          <span class="-partThree">Mon travail, c'est de les concevoir.</span>
        </h1>
        <button :title="lift ? 'Atterrissage' : 'Décollage'" @click="handleLift()" type="button" class="cover__switch" />
      </div>
        <span class="cover__mouse-dir" />
    </section>
    <section class="projects">
      <div class="projects__head">
        <h2
          class="projects__head-title -h1"
          data-aos="fade-in">
          Études de cas
        </h2>
        <div class="title-separ"
            data-aos="fade-in" />
        <p class="projects__head-subtitle -body"
            data-aos="fade-in">
          Analyses, réflexions et voyages dans des projets auxquels j'ai participé.
        </p>
      </div>
        <div class="projects__container">
          <project-card
            v-for="number in projectNumber"
            :key="number"
            :project="number-1"
            data-aos="fade-in"
            data-aos-once="true"
            :data-aos-duration="1000"
            @projects="projectCounter"
          />
        </div>
    </section>
    <section class="contact">
      <div class="contact__head -full">
        <h2 class="contact__head-title -h3"
            data-aos="fade-in">
          RDV autour d'un verre ?
        </h2>
        <p class="contact__head-p"
            data-aos="fade-in">
          Oublions les formalités ronflantes. Si vous avez un projet en tête, c'est le moment ou jamais. Et puis une <strong>idée d'exception</strong> mérite une <strong>situation d'exception</strong>.<br /><br />
          Pour la date, l'heure et le lieu :
          <a class="-darklink" href="mailto:9centis@gmail.com">
            9centis@gmail.com<svgicon icon="16-arrow-left"/>
          </a>
        </p>
      </div>
      <TheFooter :darkMode="darkMode" :darkFooter="false" />
      <ScrollTop />
    </section>
  </div>
</template>
<script>
import TheFooter from "@/components/TheFooter.vue"
import ScrollTop from '@/components/ScrollTop.vue'
import ProjectCard from '@/components/ProjectCard.vue'
import Splitting from "splitting";
// import { TimelineLite } from 'gsap';
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";

export default {
  name: 'Home',
  components: {
    ProjectCard,
    ScrollTop,
    TheFooter
  },
  props: {
    lift: Boolean,
    darkMode: String
  },
  data() {
    return {
      // creations: [
      //   {
      //     src: "https://player.vimeo.com/video/222730845?h=9dac84f2b5",
      //     thumbnail: 'isa',
      //     controls: true
      //   },{
      //     src: "https://player.vimeo.com/video/167423514?h=858dc6416b",
      //     thumbnail: 'synerg',
      //     controls: true
      //   },{
      //     src: require('@/assets/essais/poster-paralapse.jpg'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/illus-noodlezap.jpg'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/logo-metropolis.jpg'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/illus-affrenchy.jpg'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: "https://player.vimeo.com/video/122134870?h=780d990ec5",
      //     thumbnail: 'dansmaville',
      //     controls: true
      //   },{
      //     src: require('@/assets/essais/logo-uberstellar.png'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/dooock-city.jpg'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/logo-centis.png'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/poster-gits.jpg'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/poster-bigfish.jpg'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/mandala-mononoke.jpg'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/illus-gesture.jpg'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/concept-speaker.jpg'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/concept-ui-iphone5.jpg'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/concept-lens.jpg'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/concept-samsung-galaxys.jpg'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/concept-imac.jpg'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/concept-iphone4.jpg'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/concept-ibattery.jpg'),
      //     description: '',
      //     alt: ''
      //   },{
      //     src: require('@/assets/essais/splash-lizard9.jpg'),
      //     description: '',
      //     alt: ''
      //   }
      // ],
      projectNumber: 1
    }
  },
  methods: {
    splitDelay(elem) {
      const charArray = document.getElementsByClassName(elem)[0].getElementsByClassName('char');
      for(var i = 0; i < charArray.length; i++) {
        charArray[i].addEventListener("mouseenter", function(event) {
          if(event.target.classList.contains("delay")) {
            return false;
          } else {
            event.target.classList.add("mouseenter");
            event.target.classList.add("delay");
            setTimeout(function() {
              event.target.classList.remove("mouseenter");
            }, 800);
            setTimeout(function() {
              event.target.classList.remove("delay");
            }, 1600);
          }
        })
      }
    },
    handleLift() {
      const switchBtn = document.getElementsByClassName("cover__switch")[0];
      const mouseDirection = document.getElementsByClassName("cover__mouse-dir")[0];

      if(this.lift) {
        switchBtn.classList.remove('-active', 'on');
        switchBtn.classList.add('-active', 'on');
        mouseDirection.classList.remove('-active', 'show');
        mouseDirection.classList.add('-active', 'hide');
      } else {
        switchBtn.classList.remove('-active', 'on');
        switchBtn.classList.add('-active');
        mouseDirection.classList.remove('-active', 'hide');
        mouseDirection.classList.add('-active', 'show');
      }

      document.activeElement.blur();
      this.$emit('handle-lifted');
    },
    projectCounter(number) {
      this.projectNumber = number;
    }
  },
  mounted () {
    document.title = "Centis Menant"
    Splitting();
    this.splitDelay('welcome-split');
    this.splitDelay('experiment-split');
    this.$emit('is-light');

    const partTwo = document.getElementsByClassName("-partTwo")[0];
    const partThree = document.getElementsByClassName("-partThree")[0];
    const mouseDirection = document.getElementsByClassName("cover__mouse-dir")[0];
    const switchBtn = document.getElementsByClassName("cover__switch")[0];

    setTimeout(() => { partTwo.classList.add("-active") }, 200)
    setTimeout(() => { partThree.classList.add("-active") }, 400)
    setTimeout(() => { mouseDirection.classList.add("-active", "show") }, 1000)
    setTimeout(() => { switchBtn.classList.add("-active") }, 1000)
  }
}
</script>

<style lang="scss">
  @import '../assets/var.scss';

  .home {
    position: relative;
    transition: background-color 0.3s;
/* 
    .theheader {
      opacity: 0;
    } */

    &__universe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: #E6B277;
      overflow: hidden;
      z-index: 1;
      transition: opacity 0.5s, background-color 0.5s;

      & svg {
        shape-rendering: geometricprecision;
        text-rendering: geometricprecision;
      }

      &--sun {
        position: absolute;
        bottom: 0;
        max-width: 1196px;
        width: 100%;
        max-height: 910px;
        height: 100%;
        z-index: 11;
        opacity: 0;
        transition: right 3s ease-in-out 0.75s,
                    left 3s ease-in-out 0.75s,
                    opacity 3s ease-in-out .75s
        ;

        & #left-sun {
          transform: translateX(-140px);
        }
      }

      &--clouds {
        position: absolute;
          right: 10%;
        top: 50%;
        transform: translateY(-50%);
        height: 335px;
        width: 919px;
        max-width: 100%;
        z-index: 10;
        opacity: 0;
        transition: opacity 2s ease-in-out 1s;

        & path {
          transition: fill 0.5s;
        }

        &--cloud1 {
          animation: floatinClouds 20s linear infinite;
          opacity: 0;
        }

        &--cloud2 {
          animation: floatinClouds 30s linear 5s infinite;
          opacity: 0;
        }

        &--cloud3 {
          animation: floatinClouds 60s linear infinite;
          opacity: 0;
        }

        @keyframes floatinClouds {
          0% {
            transform: translateY(0) translateX(0);
            opacity: 0;
          }
          25% {
            opacity: 1;
          }
          75% {
            opacity: 1;
          }
          100% {
            opacity: 0;
            transform: translateY(-12.5rem) translateX(37.5rem);
          }
        }
      }

      &--planet {
        position: absolute;
        top: 10%;
        height: 431px;
        width: 431px;
        z-index: 9;
        opacity: 0;
        transition: left 3s ease-in-out 1.25s,
                    right 3s ease-in-out 1.25s,
                    opacity 3s ease-in-out 1.25s;

        & stop {
          transition: stop-color 0.5s;
        }
      }

      &--spaceship {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 326px;
        max-height: 228px;
        height: 100%;
        max-width: 1654px;
        width: 100%;
        z-index: 12;
        opacity: 0;
        transition: opacity 2s ease-in-out;

        & g {
          transition: fill 0.5s;
        }

        &--dust1 {
          animation: floatin 25s linear infinite alternate;
        }

        &--dust2 {
          animation: floatin 30s linear infinite alternate;
        }

        &--dust3 {
          animation: floatin 20s linear infinite alternate;
        }

        @keyframes floatin {
          0% {
            transform: translateX(-12rem);
            opacity: 0;
          }
          25% {
            opacity: 0.5;
          }
          75% {
            opacity: 0.75;
          }
          100% {
            opacity: 0;
            transform: translateX(12rem);
          }
        }
      }

      &--mountains {
        position: absolute;
        bottom: 322px;
        max-width: 801px;
        width: 100%;
        max-height: 40px;
        height: 100%;
        z-index: 13;
        opacity: 0;
        transition: right 2s ease-in-out .75s,
                    opacity 2s ease-in-out .75s;

        & path {
          transition: fill 0.5s;
        }
      }

      &--ground {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100vw;
        max-height: 326px;
        height: 100vh;
        background-color: #E6B277;
        transition: background-color 0.5s;
        z-index: 14;

        & path {
          fill: transparent;
        }
      }

      &--rightrock {
        position: absolute;
        bottom: 5%;
        max-width: 1077px;
        width: 100%;
        max-height: 631px;
        height: 100%;
        z-index: 15;
        opacity: 0;
        transition: right 2s ease-in-out 0.5s,
                    opacity 2s ease-in-out 0.5s;

        & path {
          transition: fill 0.5s;
        }
      }

      &--leftrock {
        position: absolute;
        bottom: 10%;
        max-width: 241px;
        width: 100%;
        max-height: 362px;
        height: 100%;
        z-index: 16;
        opacity: 0;
        transition: left 2s ease-in-out 0.5s,
                    opacity 2s ease-in-out 0.5s;

        & path {
          transition: fill 0.5s;
        }
      }

      &--human {
        position: absolute;
        left: 50%;
        transform: translateX(-50%) translateY(-10%);
        bottom: 10%;
        max-width: 141px;
        max-height: 202px;
        z-index: 20;

        & path {
          transition: fill 0.5s;
        }
      }

      &.hide {
        opacity: 0;

        & .home__universe--sun {
          left: -5%;
          opacity: 0;
          transition: all 0.5s ease-in-out 0s;
        }

        & .home__universe--clouds {
          opacity: 0;
          transition: all 0.5s ease-in-out 0s;
        }

        & .home__universe--planet {
          right: 7%;
          opacity: 0;
          transition: all 0.5s ease-in-out 0s;
        }

        & .home__universe--spaceship {
          opacity: 0;
          transition: all 0.5s ease-in-out 0s;
        }

        & .home__universe--mountains {
          right: -5%;
          opacity: 0;
          transition: all 0.5s ease-in-out 0s;
        }

        & .home__universe--rightrock {
          right: -5%;
          opacity: 0;
          transition: all 0.5s ease-in-out 0s;
        }

        & .home__universe--leftrock {
          left: -5%;
          opacity: 0;
          transition: all 0.5s ease-in-out 0s;
        }
      }

      &.show {
        opacity: 1;

        & .home__universe--sun {
          left: 0;
          opacity: 1;
        }

        & .home__universe--clouds {
          opacity: 1;
        }

        & .home__universe--planet {
          right: 10%;
          opacity: 1;
        }

        & .home__universe--spaceship {
          opacity: 1;
        }

        & .home__universe--mountains {
          right: 0;
          opacity: 1;
        }

        & .home__universe--rightrock {
          right: 0;
          opacity: 1;
        }

        & .home__universe--leftrock {
          left: 0;
          opacity: 1;
        }
      }
    }

    & svg {
      overflow: visible;
    }

    &__shapes {
      position: absolute;
      height: 100vh;
      width: 100vw;
      z-index: 3;
      
      &.hide {
        opacity: 0;
        z-index: 1;
      }

      &.show {
        opacity: 1;
        z-index: 3;
      }
    }

    &__line {
      position: absolute;
      top: 0;
      left: 0;
      width: 36.25rem;
      height: 25.625rem;
      stroke: $grey-300;
      transition: opacity 0.5s, stroke 0.3s;
    }

    &__circles {
      position: absolute;
      top: 50%;
      right: 10vw;
      transform: translateY(-50%) rotateZ(0);
      height: 41.5rem;
      width: 41.5rem;
      transform-origin: center;
      animation: solarref 20s linear infinite;
      transition: opacity 0.5s;
      z-index: 3;

      & .earth-rot {
        position: relative;
        transform-origin: center;
        transform-box: fill-box;
        animation: earthref 15s linear infinite;
        transform: translateY(11.75rem) rotateZ(0);
      }

      & .circle-ring1 {
        position: relative;
        transform-origin: center;
        transform-box: fill-box;
        animation: ringrot1 40s linear infinite;
        transform: rotateY(35deg);
        stroke: $grey-300;
        transition: stroke 0.3s;
      }

      & .circle-ring2 {
        position: relative;
        transform-origin: center;
        transform-box: fill-box;
        stroke-dasharray: 6;
        animation: normalrot 20s linear infinite;
        stroke: $grey-300;
        transition: stroke 0.3s;
      }

      & .circle-ring3 {
        position: relative;
        transform-origin: center;
        transform-box: fill-box;
        animation: ringrot2 70s linear infinite;
        stroke: $grey-300;
        transition: stroke 0.3s;
      }

      & .sun-shape {
        position: relative;
        z-index: 3;
        stroke: $grey-400;
        fill: transparent;
        transition: fill 0.3s, stroke 0.3s;

        &:hover {
          stroke: $grey-500;
          fill: $grey-100;
        }

        @keyframes bouncedSun {
          to {
            transform: scale(1.5);
            opacity: 0;
          }
        }
      }

      & .earth-shape {
        stroke: $grey-400;
        transition: stroke 0.3s;
      }

      & .moon-shape {
        stroke: $grey-300;
        transition: stroke 0.3s;
      }

      @keyframes solarref {
        to {
          transform: translateY(-50%) rotateZ(360deg);
        }
      }

      @keyframes normalrot {
        to {
          transform: rotateZ(-540deg);
        }
      }

      @keyframes ringrot1 {
        0% {
          transform: rotateY(35deg);
        }
        50% {
          transform: rotateY(75deg);
        }
      }

      @keyframes ringrot2 {
        0% {
          transform: rotateY(0deg);
        }
        50% {
          transform: rotateY(60deg);
        }
      }

      @keyframes earthref {
        to {
          transform: translateY(11.75rem) rotateZ(360deg);
        }
      }
    }

    & .cover {
      position: relative;
      width: auto;
      height: 100vh;
      margin-top: -10rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      z-index: 8;

      & .wrap {
        max-width: 100vw;
        margin: auto 0;
      }

      & .welcome-split.hide,
      & .experiment-split.hide {
        animation: disappear 2s;
        animation-fill-mode: both;
        display: none;
      }

      @keyframes disappear {
        from {
          display: block;
        }
        to {
          display: none;
        }
      }

      & .welcome-split .word,
      & .experiment-split .word {
        position: relative;
        display: inline-block;
        cursor: default;
      }

      & .welcome-split .whitespace,
      & .experiment-split .whitespace {
        cursor: default;
      }

      & .welcome-split .-partOne .char,
      & .welcome-split .-partTwo.-active .char,
      & .welcome-split .-partThree.-active .char,
      & .experiment-split .char {
        position: relative;
        visibility: visible;
        animation: slideIn 0.5s cubic-bezier(.5, 0, .5, 1) both;
        animation-delay: calc(12ms * var(--char-index));
        margin: 0.125rem 0;
        z-index: 2;
      }

      & .welcome-split .-partTwo .char,
      & .welcome-split .-partThree .char {
        position: relative;
        margin: 0.125rem 0;
        visibility: hidden;
        z-index: 2;
      }

      & .welcome-split .-partOne .mouseenter,
      & .welcome-split .-partTwo.-active .mouseenter,
      & .welcome-split .-partThree.-active .mouseenter,
      & .experiment-split .mouseenter {
        animation: moveIn 1s;
        z-index: 1;
      }

      & .welcome-split.show .char,
      & .experiment-split.show .char {
        display: inline-block;
        opacity: 1;
        z-index: 2;
      }

      & .welcome-split.hide .char,
      & .experiment-split.hide .char {
        animation: moveIn 1s;
        animation-delay: calc(12ms * var(--char-index));
        opacity: 0;
        z-index: 1;
      }

      @keyframes slideIn {
        0% {
          transform: translateY(-0.5rem);
          opacity: 0;
        }
      }

      @keyframes moveIn {
        40% {
          transform: translateY(-0.5rem) rotateX(12deg);
        }
        80% {
          transform: translateY(0.3rem) rotateX(-3deg);
          opacity: 0;
        }
      }

      &__title {
        text-align: left;
        max-width: 45rem;
        font-size: $px40;
        line-height: 3.25rem;

        & > span {
          display: block;
          font-family: $lineal;
          font-weight: 400;
          color: $grey-900;
          transition: color 0.3s;

          & strong {
            font-weight: 600;
          }
        }
      }

      &__switch {
        position: relative;
        grid-row-start: 2;
        grid-column: 2 / span 8;
        width: 4rem;
        border-radius: 1rem;
        border: none;
        background-color: transparent;
        box-shadow: inset 0 0 0 0.0625rem $grey-300;
        padding: 1rem 0;
        margin: 0;
        margin-top: 2rem;
        z-index: 1;
        transition: all 0.3s;
        opacity: 0;
        cursor: pointer;

        &.-active {
          animation: pageFadeIn 1s both;
        }

        &::before {
          content: '';
          position: absolute;
          top: 0.425rem;
          left: 0.5rem;
          height: 1.125rem;
          width: 1.5rem;
          aspect-ratio: 1 / 1;
          background-color: $white;
          box-shadow: inset 0 0 0 0.125rem $grey-500;
          border-radius: 0.575rem;
          z-index: 3;
          transition: all 0.3s;
          transform-origin: center;
        }

        &:hover::before,
        &:focus::before,
        &:active::before {
          box-shadow: inset 0 0 0 0.125rem $grey-600;
          left: 0.65rem;
        }

        &:hover,
        &:focus,
        &:active {
          box-shadow: inset 0 0 0 0.0625rem $grey-500;
        }

        &::after {
          content: '';
          position: absolute;
          top: 0.9375rem;
          left: 0.9375rem;
          right: 0.9375rem;
          height: 0.125rem;
          background-color: $grey-200;
          border-radius: 0.125rem;
          z-index: 2;
          transition: all 0.3s;
        }

        &:hover::after,
        &:focus::after,
        &:active::after {
          background-color: $grey-500;
        }

        &.on {
          background-color: $black50;
          box-shadow: inset 0 0 0 0 $grey-500;
  
          &:hover,
          &:focus,
          &:active {
            background-color: $grey-900;
          }
          
          &::before {
            content: '';
            position: absolute;
            left: 2rem;
            background-color: $white;
            box-shadow: inset 0 0 0 0 $grey-400;
          }
  
          &:hover::before,
          &:focus::before,
          &:active::before {
            left: 1.825rem;
          }
  
          &::after {
            background-color: $white20;
          }

          &:hover::after,
          &:focus::after,
          &:active::after {
            background-color: $white;
          }
        }
      }

      &__mouse-dir {
        position: absolute;
        height: 2.25rem;
        width: 1.25rem;
        border-radius: 1rem;
        bottom: 6rem;
        left: 50%;
        box-shadow: inset 0 0 0 0.0625rem $grey-500;
        transform: translateX(-50%);
        transition: opacity 0.5s;
        opacity: 0;
        animation: move 2s infinite;

        &::before {
          content: '';
          position: absolute;
          top: 65%;
          left: 50%;
          height: 0.5rem;
          width: 0.125rem;
          border-radius: 0.125rem;
          transform: translateX(-50%) translateY(-35%);
          background-color: $grey-300;
        }

        &.show.-active {
          opacity: 1;
        }

        &.hide {
          opacity: 0;
        }
      }

      @keyframes move {
        0% {
          transform: translateY(0rem) translateX(-50%);
        }
        33% {
          transform: translateY(1.5rem) translateX(-50%);
        }
        66% {
          transform: translateY(1.5rem) translateX(-50%);
        }
        100% {
          transform: translateY(0rem) translateX(-50%);
        }
      }
    }

    & .projects {
      position: relative;
      margin-top: $px-40;
      padding-top: $px120;
      min-height: 100vh;
      width: auto;
      z-index: 9;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background-color: $grey-100;
        transition: background-color 0.3s;
        z-index: -1;
      }    
  
      & .title-separ {
        width: $px40;
        height: $px2;
        background-color: $grey-900;
        transition: background-color 0.3s;
        margin: auto;
      }

      &__head {
        margin: 0 auto;
        text-align: left;
        padding: 0 $px64 $px40 $px64;

        &-title {
          color: $grey-900;
          font-size: $px48;
          line-height: $px64;
          margin-bottom: $px16;
          text-align: center;
          transition: color 0.3s;
        }

        &-subtitle {
          color: $grey-700;
          margin: $px24 0 $px8;
          text-align: center;
          transition: color 0.3s;
        }
      }

      &__container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: $px24 $px64 $px120 $px64;
        column-gap: 0;
      }
    }

    & .contact {
      position: relative;
      min-height: 100vh;
      width: 100vw;
      display: flex;
      flex-direction: column;
      z-index: 9;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background-color: $white;
        transition: background-color 0.3s;
        z-index: -1;
      }
      
      &__head {
        position: relative;
        text-align: left;
        max-width: 45rem;
        padding: 10rem 0;

        &-title {
          position: relative;
          color: $grey-900;
          transition: color 0.3s;
          font-family: $lineal;
          font-weight: 600;
          margin-bottom: $px8;
        }

        &-p {
          @extend .-h4;

          transition: color 0.3s;
          font-weight: 400;

          & a {
            color: $grey-600;
            transition: color 0.3s;

            & svg {
              position: relative;
              align-self: center;
              margin-left: $px-16;
              height: $px24;
              width: $px24;
              transform: translateX(0) translateY(0.25rem) rotateZ(180deg) scale(0);
              fill: transparent;
              transition: transform 0.5s, fill 0.3s;
            }

            &:hover,
            &:focus,
            &:active {
              color: $grey-900;
        
            & svg {
              transform: translateX($px30) translateY(0.25rem) rotateZ(180deg) scale(1);
              fill: $grey-900;
              transition: transform 0.3s, fill 0.5s;
            }
            }
          }
        }
      }
    }

    & .theheader {
      animation: pageFadeIn 1s 5s both;
      opacity: 0;
    }
  }

  .landing {
    color: white;

    & .home__circles {
      top: 0;
      right: 50%;
      transform: translateY(0) translateX(-50%) rotateZ(0);
      animation: solarrefdark 20s linear infinite;
    }

    @keyframes solarrefdark {
      to {
        transform: translateY(0) translateX(-50%) rotateZ(360deg);
      }
    }
  }

  @keyframes pageFadeIn {
    to {
      display: block;
      opacity: 1;
    }
  }

  @media screen and (max-width: $laptop) {
    .home {
      & .projects {
        min-height: auto;
      }

      &__universe {
        &--spaceship {
          left: 0;
          transform: translateX(-400px);
        }
      }
    }
  }

  @media screen and (max-width: $phone) {
    .home {
      .cover {
        min-height: 100vh;
        height: auto;

        &__title {
          font-size: 1.875rem;
          margin-top: 15rem;
          line-height: 2.5rem;
          text-shadow: 0 0 0.25rem $white;
          transition: text-shadow 0.3s;
        }

        & .welcome-split {
          & strong {
            display: block;
          }
        }

        &__switch {
          margin-bottom: 15rem;
        }

      }

      &__shapes {
        display: none;
      }

      &__universe {
        &--sun {
          & #left-sun {
            transform: translateX(-480px);
          }
        }

        &--planet {
          left: 10%;
          transform: scale(0.8);
        }

        &--spaceship {
          left: 0;
          transform: translateX(-600px);
          bottom: 204px;
        }

        &--mountains {
          display: none;
        }

        &--ground {
          max-height: 204px;
        }

        &--rightrock {
          bottom: 8%;
          max-width: 877px;
          max-height: 431px;
          transform: scale(0.55);
        }

        &--leftrock {
          bottom: 0%;
          transform: scale(0.55) translateX(-100px);
        }

        &--human {
          left: 55%;
          transform: translateX(-50%) translateY(-10%) scale(0.7);
          bottom: 6%;
        }
      }
      
      & .projects {
        margin-top: 0;
        padding-top: $px80;


        &__head {
          padding: 0 $px40;
        }

        &__container {
          padding: $px24 0 $px40;
        }
      }

      & .contact {
        width: auto;

        &__head {
          width: auto;
        }
      }
    }
  }

  .darkmode {
    & .home {
      background-color: $dark-800;

      &__universe {
        overflow: hidden;
        background-color: $dark-800;

        &--sun {
          animation: modeChanged 0.5s both;
          opacity: 0;
          transform: scaleX(-1);
          
          & path {
            fill: $night-100;
          }
        }

        &--clouds {
          & path {
            fill: $night-500;
          }
        }

        &--planet {
          transform: scaleX(-1);

          & stop {
            stop-color: $night-500;
          }

          & stop:first-child {
            stop-color: $night-500;
          }
        }

        &--spaceship {
          & g:first-child {
            fill: $night-600;
          }

          &--dust {
            fill: $night-400;
          }
        }

        &--mountains {
          & path {
            fill: $night-700;

            &.mountain_light {
              fill: $night-600;
            }
          }

        }

        &--ground {
          background-color: $night-500;
        }

        &--rightrock {
          & .rock_light {
             fill: $night-400;
          }

          & .rock_lighter {
             fill: $night-200;
          }
        }

        &--leftrock {
          & .rock_lighter {
             fill: $night-200;
          }
        }

        &--human {
          transform: scaleX(-1);

          & .human_light {
            fill: $night-200;  
          }
        }

        &.hide {

          & .home__universe--sun {
            left: auto;
            right: -5%;
          }
        }

        &.show {

          & .home__universe--sun {
            right: 0%;
            left: auto;
          }
        }
      }

      &__line {
        stroke: $white20;
      }

      &__circles {

        & .circle-ring1 {
          stroke: $white20;
        }

        & .circle-ring2 {
          stroke: $white20;
        }

        & .circle-ring3 {
          stroke: $white20;
        }

        & .sun-shape {
          stroke: $white50;
        }

        & .earth-shape {
          stroke: $white50;
        }

        & .moon-shape {
          stroke: $white20;

        }
      }

      & .cover {

        &__title {

          & > span {
            color: $white;
          }
        }

        &__switch {
          box-shadow: inset 0 0 0 0.0625rem $white20;

          &::before {
            background-color: $grey-900;
            box-shadow: inset 0 0 0 0.125rem $white;
          }

          &:hover::before,
          &:focus::before,
          &:active::before {
            box-shadow: inset 0 0 0 0.125rem $white;
            background-color: $white;
          }

          &:hover,
          &:focus,
          &:active {
            box-shadow: inset 0 0 0 0.0625rem $white;
          }

          &::after {
            content: '';
            position: absolute;
            top: 0.9375rem;
            left: 0.9375rem;
            right: 0.9375rem;
            height: 0.125rem;
            background-color: $white50;
            border-radius: 0.125rem;
            z-index: 2;
            transition: all 0.3s;
          }

          &:hover::after,
          &:focus::after,
          &:active::after {
            background-color: $white;
          }

          &.on {
            background-color: $white5;
            box-shadow: inset 0 0 0 0 $white50;
    
            &:hover,
            &:focus,
            &:active {
              background-color: $white10;
            }
            
            &::before {
              content: '';
              position: absolute;
              left: 2rem;
              background-color: $white;
              box-shadow: inset 0 0 0 0 $white50;
            }
    
            &:hover::before,
            &:focus::before,
            &:active::before {
              left: 1.825rem;
            }
    
            &::after {
              background-color: $white20;
            }

            &:hover::after,
            &:focus::after,
            &:active::after {
              background-color: $white;
            }
          }
        }

        &__mouse-dir {
          box-shadow: inset 0 0 0 0.0625rem $white50;

          &::before {
            background-color: $white20;
          }
        }
      }

      & .projects {

        &::before {
          background-color: $dark-700;
        }    
    
        & .title-separ {
          background-color: $white;
        }

        &__head {

          &-title {
            color: $white;
          }

          &-subtitle {
            color: $white50;
          }
        }

        &__container {
        }
      }

      & .contact {

        &::before {
          background-color: $dark-800;
        }
        
        &__head {

          &-title {
            color: $white;
          }

          &-p {
            color: $white50;
            
            & a {
              color: $white50;

              &:hover,
              &:focus,
              &:active {
                color: $white;
          
              & svg {
                fill: $white;
              }
              }
            }
          }
        }
      }
    }

    .landing {
      color: $dark-800;
    }


    @media screen and (max-width: $phone) {
      .home {
        &__universe {
          &--human {
            left: 45%;
            transform: translateX(-50%) translateY(-10%) scale(0.7) scaleX(-1);
          }
        }

        & .cover {
          &__title {
            text-shadow: 0 0 0.5rem $dark50;
          }
        }
      }
    }
  }
</style>